var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-add"},[_c('svg',{attrs:{"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}},[_c('path',{attrs:{"fill":"#fff","d":"M22 10H12V0h-2v10H0v2h10v10h2V12h10z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }